/**
 * Whether a message's audio control should offer Stop rather than Play.
 *
 * Two players can voice an assistant reply:
 * - the <audio> element, started by ConversationComponent's handleMessagePlay,
 *   which records the message in `currentPlayingIndex`;
 * - for a streamed turn (`item.streamed`), the Web Audio queue in ttsStream, which
 *   sets `sharedState.talking` through onFirstAudio and never touches
 *   `currentPlayingIndex`.
 *
 * Checking only `currentPlayingIndex` showed Play while a streamed reply was being
 * spoken, and pressing it started the same reply a second time over the first.
 */
export function isMessageAudioPlaying({
  index,
  currentPlayingIndex,
  talking,
  isStreamed,
  isLastAssistantMessage,
}) {
  if (!talking) {
    return false;
  }

  // The <audio> element is playing a specific message: only that one is playing.
  if (currentPlayingIndex !== null && currentPlayingIndex !== undefined) {
    return currentPlayingIndex === index;
  }

  // Nothing started through the <audio> element, so the speech is the streamed
  // reply, which is always the latest assistant message.
  return Boolean(isStreamed && isLastAssistantMessage);
}
